// import {
//   AutoSizer,
//   CellMeasurer,
//   CellMeasurerCache,
//   List,
//   WindowScroller,
// } from "react-virtualized";
import { memo, useRef, useState } from "react";

import useMyActivityStore from "@/hooks/useMyActivitiesStore";
import ActivityItemV3 from "./ActivityItemV3";
import useIntersectionObserver from "@/hooks/useIntersectionObserver";
import { LoadingOutlined } from "@ant-design/icons";

// const cache = new CellMeasurerCache({
//   defaultHeight: 100, // fallback height
//   fixedWidth: true,
//   minHeight: 50,
// });

const ListActivityContainer = () => {
  const { processedActivities } = useMyActivityStore();
  const [endSlice, endSliceSet] = useState(10);

  const btnMoreRef = useRef<HTMLDivElement | null>(null);
  
  useIntersectionObserver(btnMoreRef, {}, () => {
    endSliceSet((prev) => prev + 10);
  });

  // return (
  //   Array.isArray(processedActivities) && (
  //     <WindowScroller>
  //       {({ isScrolling, onChildScroll, scrollTop, height }) => (
  //         <AutoSizer disableHeight>
  //           {({ width }) => (
  //             <List
  //               ref="List"
  //               className=""
  //               autoHeight
  //               onScroll={onChildScroll}
  //               scrollTop={scrollTop}
  //               isScrolling={isScrolling}
  //               height={height}
  //               overscanRowCount={20}
  //               rowCount={processedActivities?.length || 0}
  //               rowHeight={({ index }) => cache.rowHeight({ index }) + 16}
  //               deferredMeasurementCache={cache}
  //               rowRenderer={({ key, index, style, parent }) => (
  //                 <CellMeasurer
  //                   key={key}
  //                   cache={cache}
  //                   parent={parent}
  //                   columnIndex={0}
  //                   rowIndex={index}
  //                 >
  //                   {({ measure, registerChild }) => (
  //                     <div ref={registerChild} style={style}>
  //                       <ActivityItemV3 onMeasured={measure} {...processedActivities[index]} />
  //                     </div>
  //                   )}
  //                 </CellMeasurer>
  //               )}
  //               width={width}
  //             />
  //           )}
  //         </AutoSizer>
  //       )}
  //     </WindowScroller>
  //   )
  // );

  return (
    Array.isArray(processedActivities) && (
      <div className="grid grid-cols-1 gap-4">
        {processedActivities
          ?.slice(0, endSlice)
          ?.map((item, index) => <ActivityItemV3 key={index} {...item} />)}
        {processedActivities?.length > endSlice && (
          <div className="flex justify-center" ref={btnMoreRef}>
            <LoadingOutlined className="animate-spin text-primary text-xl" />
          </div>
        )}
      </div>
    )
  );
};

export default memo(ListActivityContainer);
